// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1983j","content":"styles_content__168py","textInputWidthDefault":"styles_textInputWidthDefault__2paGB","flexButton":"styles_flexButton__20LMA"};